'use client'

import React from 'react'
import dynamic from 'next/dynamic'

const Gallery = dynamic(() => import('@/app/gallery/gallery'), { ssr: false })

export default function GalleryClientComponent() {
	return <Gallery />
}
